import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { OrgContext, UserContext } from '../../../objects/Context';
import './SettingsComponents.css';

function OrgGeneralSettings() {
    const { org, setOrg } = useContext(OrgContext);
    const { user } = useContext(UserContext);
    const [orgName, setOrgName] = useState(org.name || '');
    const [isOrgNameChanged, setIsOrgNameChanged] = useState(false);
    
    // Check if name has changed whenever name state updates
    useEffect(() => {
        setIsOrgNameChanged(orgName !== (org.name || ''));
    }, [orgName, org.name]);

    const updateOrgName = async (id, name) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/orgs/update-name/${id}`, { newName: name }, { withCredentials: true });
            setOrg(prevOrg => ({...prevOrg, name: name}));
            setIsOrgNameChanged(false);
        } catch (error) {
            console.error('Error updating organization name:', error);
        }
    };

    const handleUpdateOrg = () => {
        if (isOrgNameChanged) {
            updateOrgName(org.id, orgName);
        }
    };
    
    return (
        <div className="settings-component">
            <div className="settings-header">
                <div className="settings-title-group">
                    <h1 className="settings-title">Organization General Settings</h1>
                    <h2 className="settings-subtitle">Update your organization general settings</h2>
                </div>
            </div>
            <div className="content">
                <div className="item-list">
                    <div className="text-item-label">
                        <div className="title">Organization Name</div>
                        <div className="description">The name associated with your organization</div>
                        <input className="text-item-value" type="text" value={orgName} onChange={(e) => setOrgName(e.target.value)} placeholder="Enter your organization name"/>
                    </div>
                    <div className="text-item-label">
                        <div className="title">Contact Email</div>
                        <div className="description">Vairo will use this email for communications about your organization.</div>
                        <input className="text-item-value" type="text" value={user.email} disabled={true} placeholder="Enter your organization email"/>
                    </div>
                </div>
                <div className="button-container">
                    <button className="save-button" disabled={!isOrgNameChanged} onClick={handleUpdateOrg}>
                        Update Organization
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OrgGeneralSettings;